import { LMS_BASE_URL } from 'config';

import axios from 'axios';

const authHeaders = () => ({
  'Content-Type': 'application/json',
  'X-CSRFToken': localStorage.getItem('lms-csrf-token'),
});

const fetchCourses = (params) => axios({
  withCredentials: true,
  method: 'GET',
  headers: authHeaders(),
  url: `${LMS_BASE_URL}adminpanel/courses/manage/`,
  params,
});

const createCourse = (data) => axios({
  withCredentials: true,
  method: 'POST',
  headers: authHeaders(),
  url: `${LMS_BASE_URL}adminpanel/courses/create/`,
  data,
});

/* eslint-disable import/prefer-default-export */
export const coursesService = {
  fetchCourses,
  createCourse,
};
